import styled from 'styled-components/native';

import { layout, LayoutProps } from 'styled-system';

import { Colors } from 'theme/colors';

export const BubbleView = styled.View<LayoutProps>`
  position: relative;
  border-radius: 22px;
  background-color: ${Colors.gallery};
  padding: 18px 35px;
  margin-bottom: 5px;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  display: flex;
  justify-content: center;
  width: fit-content;
  align-items: center;
  ${layout}
`;

export const BubbleTip = styled.View`
  position: absolute;
  top: -10px;
  height: 0;
  width: 0;
  border-bottom-width: 10px;
  border-bottom-color: ${Colors.gallery};
  border-left-width: 10px;
  border-left-color: transparent;
  border-right-width: 10px;
  border-right-color: transparent;
`;
